import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** リース物件元本返済予定表の帳票種類ENUM */
enum LaArtPrinRepaySchedRptType {
  /**リース物件元本返済予定表(集計表) */
  principalRepaymentScheduleSummary = '1',
  /**リース物件元本返済予定表(明細表) */
  principalRepaymentScheduleStatement = '2',
}

const nameConfig = {
  principalRepaymentScheduleSummary: new Map([[Locale.ja, 'リース物件元本返済予定表(集計表)']]),
  principalRepaymentScheduleStatement: new Map([[Locale.ja, 'リース物件元本返済予定表(明細表)']]),
};

const toEnum = rawValueToEnum(
  LaArtPrinRepaySchedRptType,
  LaArtPrinRepaySchedRptType.principalRepaymentScheduleSummary,
);
const toDisplay = enumToName(LaArtPrinRepaySchedRptType, nameConfig);
const toDisplayWithPrefix = enumToName(LaArtPrinRepaySchedRptType, nameConfig, { prefix: true });

export const laArtPrinRepaySchedRptType = {
  enum: LaArtPrinRepaySchedRptType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { LaArtPrinRepaySchedRptType };
